/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Detail_Reviews_CountInputs */

const en_directory_detail_reviews_count = /** @type {(inputs: Directory_Detail_Reviews_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ratings`)
};

const zh_directory_detail_reviews_count = /** @type {(inputs: Directory_Detail_Reviews_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 条评分`)
};

/**
* | output |
* | --- |
* | "{count} ratings" |
*
* @param {Directory_Detail_Reviews_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_reviews_count = /** @type {((inputs: Directory_Detail_Reviews_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Reviews_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_reviews_count(inputs)
	return zh_directory_detail_reviews_count(inputs)
});
export { directory_detail_reviews_count as "directory.detail.reviews_count" }